// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"b05a4407","215":"d6b9cc2f","347":"e2d723fa","453":"f502aaa6","498":"56233b46","678":"9b7194f0","762":"a7a4e94b","948":"da8f2d9a"}[chunkId] + ".chunk.js";
};